import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: "AIzaSyB7Yvw-P_xtKR0FJPUe9yPyiI0QWLK-DPk",
  authDomain: "workout-tracker-app-2b10d.firebaseapp.com",
  projectId: "workout-tracker-app-2b10d",
  storageBucket: "workout-tracker-app-2b10d.firebasestorage.app",
  messagingSenderId: "386855058946",
  appId: "1:386855058946:web:cd041b887633a38dfbb11b"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Export auth and db instances
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);